import {
  Users,
  Building2,
  UserCog,
  Network,
  Scale,
  // Sparkles,
  CalendarDays,
  FileText,
  ImageIcon,
} from "lucide-react";
import { useEffect } from "react";
import { useResource } from "@/hooks/useResource";
import { dashboardService } from "@/services/dashboardService";
import { useSettingsStore } from "@/store/settingsStore";
import { useUiStore } from "@/store/uiStore";
import { PageHeader } from "@/components/molecules/PageHeader";
import { StatCard } from "@/components/molecules/StatCard";

const TILES = [
  { key: "contacts", label: "Contacts", to: "/contacts", icon: <Users size={18} /> },
  { key: "properties", label: "Properties", to: "/properties", icon: <Building2 size={18} /> },
  { key: "users", label: "Users", to: "/users", icon: <UserCog size={18} /> },
  { key: "branches", label: "Branches", to: "/branches", icon: <Network size={18} /> },
  { key: "legalEntities", label: "Legal Entities", to: "/legal-entities", icon: <Scale size={18} /> },
  // { key: "leads", label: "Leads", to: "/leads", icon: <Sparkles size={18} /> },
  { key: "diaryEntries", label: "Diary Entries", to: "/diary", icon: <CalendarDays size={18} /> },
  { key: "documents", label: "Documents", to: "/documents", icon: <FileText size={18} /> },
  { key: "images", label: "Images", to: "/images", icon: <ImageIcon size={18} /> },
] as const;

export function OverviewDashboardPage() {
  const { legalEntityId, branchId } = useSettingsStore();
  const { startPageLoading, stopPageLoading } = useUiStore();
  const { data, loading, error } = useResource(
    () => dashboardService.stats({ legalEntityId: legalEntityId || undefined, branchId: branchId || undefined }),
    [legalEntityId, branchId]
  );

  useEffect(() => {
    if (loading) startPageLoading();
    else stopPageLoading();
    return () => stopPageLoading();
  }, [loading, startPageLoading, stopPageLoading]);

  return (
    <div className="h-full overflow-auto">
      <PageHeader
        title="Dashboard"
        subtitle="Live snapshot of every entity unified inside Atlas."
      />
      <div className="px-6 pb-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {TILES.map((tile, i) => (
          <StatCard
            key={tile.key}
            style={{ animationDelay: `${i * 60}ms` }}
            label={tile.label}
            icon={tile.icon}
            to={tile.to}
            loading={loading}
            value={error ? "—" : (data?.[tile.key] ?? 0).toLocaleString()}
            hint="across all CRMs"
          />
        ))}
      </div>
    </div>
  );
}
